/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgGummy = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M8.514 6.836a1 1 0 0 1 1.972.328l-1 6a1 1 0 0 1-1.972-.328z" />
        <path
          clipRule="evenodd"
          d="M15.74 2.004a4 4 0 0 1 3.77 3.402l1.8 12a4 4 0 0 1-3.727 4.588l-.227.006H6.645a4 4 0 0 1-3.984-4.367l.028-.227 1.8-12A4 4 0 0 1 8.444 2h7.112zM8.444 4a2 2 0 0 0-1.977 1.703l-1.8 12A2 2 0 0 0 6.645 20h10.71a2 2 0 0 0 1.978-2.297l-1.8-12A2 2 0 0 0 15.556 4z"
          fillRule="evenodd"
        />
      </g>
    </g>
  </Icon>
);
export { SvgGummy as Gummy };
